import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "@/components/Toast";
import { X, MapPin, Building2, ChevronRight } from "lucide-react";
import { DeletedUserBadge } from "@/components/DeletedUserBadge";

/** Prompt AD (2026-09-21) — CAMBIO 5: detalle real detrás de "Supervisores
 * en marcha" -- antes llevaba a Clientes, ahora muestra quién está en
 * marcha (nombre, objetivo, sede, desde qué hora) y deja entrar al detalle
 * de esa marcación. El número (active_checkins) no cambia, sigue siendo el
 * mismo cálculo de siempre (marcaciones sin checkout_at). */
export function SupervisorsOnDutyModal({ onClose }) {
  const nav = useNavigate();
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/supervisor-checkins?active_only=true");
        setRows(data);
      } catch (e) { setErr(formatApiError(e)); toast.error(formatApiError(e)); }
    })();
  }, []);

  const goToDetail = (supervisorId) => { onClose(); nav(`/admin/marcaciones?supervisor_id=${supervisorId}`); };

  return (
    <div className="modal-overlay" onClick={onClose} data-testid="supervisors-on-duty-modal-overlay">
      <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 560, maxHeight: "80vh", overflowY: "auto" }} data-testid="supervisors-on-duty-modal">
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 4 }}>
          <h3 style={{ margin: 0 }} data-testid="supervisors-on-duty-title">Supervisores en marcha ({rows?.length ?? 0})</h3>
          <button onClick={onClose} className="btn-ghost" style={{ padding: 6 }} data-testid="supervisors-on-duty-close"><X size={16} /></button>
        </div>
        <p style={{ fontSize: 12, color: "var(--invict-text-muted)", margin: "0 0 14px" }}>
          Marcaciones de supervisor sin cierre todavía. Tocá una fila para ver el detalle en Marcaciones.
        </p>
        {err && <div className="card" style={{ borderColor: "#BF3437", color: "#8E2629" }}>{err}</div>}
        {!rows && !err && <div className="skel" style={{ height: 100 }} />}
        {rows && rows.length === 0 && <div style={{ fontSize: 13, color: "var(--invict-text-muted)" }} data-testid="supervisors-on-duty-empty">Nadie tiene una marcación en marcha ahora.</div>}
        {rows && rows.length > 0 && (
          <div style={{ display: "flex", flexDirection: "column", gap: 6 }} data-testid="supervisors-on-duty-list">
            {rows.map((r) => (
              <button key={r.id} onClick={() => goToDetail(r.supervisor_id)} data-testid={`supervisors-on-duty-row-${r.id}`}
                style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", textAlign: "left", padding: "10px 12px", border: "1px solid var(--invict-bone-3)", borderRadius: 4, background: "var(--invict-bone-2)", cursor: "pointer" }}>
                <div>
                  <div style={{ fontWeight: 800, fontSize: 13, color: "#0A0A0A" }}>{r.supervisor_name}{r.supervisor_deleted && <DeletedUserBadge id={r.id} />}</div>
                  <div style={{ fontSize: 11, color: "var(--invict-text-muted)", marginTop: 2 }}>
                    <Building2 size={11} style={{ marginRight: 4, verticalAlign: "-1px" }} />{r.client_name || "Oficina"}
                    {r.site_name && <><MapPin size={11} style={{ marginLeft: 8, marginRight: 4, verticalAlign: "-1px" }} />{r.site_name}</>}
                    {" · desde "}{new Date(r.checkin_at).toLocaleTimeString("es-AR", { hour: "2-digit", minute: "2-digit" })}
                  </div>
                </div>
                <ChevronRight size={14} style={{ color: "var(--invict-text-muted)" }} />
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
